/* global DEBUG */
import { LoggerFactory } from "lines-logger";

// TODO: IF PRODUCTION use new LoggerFactory('disable);
let loggerFactory = new LoggerFactory(process.env.VUE_APP_LOGGER);

export const get = ( ident ) => {
    return loggerFactory.getLogger(ident);
}
